import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
@Component({
  selector: 'jsg-hearing-associate-materials-upload-message-panel-view',
  templateUrl:
    './hearing-associate-materials-upload-message-panel-view.component.html',
  styleUrls: [
    './hearing-associate-materials-upload-message-panel-view.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingAssociateMaterialsUploadMessagePanelViewComponent {
  @Input() panelType: 'error' | 'info';
  @Input() messageText: string;
  @Input() canClose: boolean = false;

  @Output() panelClose = new EventEmitter();

  onPanelClose = () => {
    this.panelClose.emit();
  };
}
